import cx from 'clsx';
import React from 'react';

import styles from './CurrencySymbol.module.scss';

interface CurrencySymbolPropTypes {
  isPrefixElementPosition: boolean;
  isPrefixCurrencySymbol: boolean;
  currencySymbol: string;
  elementTestId?: string;
}

const CurrencySymbol: React.FC<CurrencySymbolPropTypes> = ({
  isPrefixElementPosition,
  isPrefixCurrencySymbol,
  currencySymbol,
  elementTestId = '',
}: CurrencySymbolPropTypes) => {
  if (
    (isPrefixCurrencySymbol && !isPrefixElementPosition) ||
    (!isPrefixCurrencySymbol && isPrefixElementPosition)
  )
    return null;

  return (
    <span
      className={cx(
        styles.currencySymbol,
        isPrefixCurrencySymbol
          ? styles.currencySymbolPrefix
          : styles.currencySymbolSuffix
      )}
      data-testid={elementTestId}
    >
      {currencySymbol}
    </span>
  );
};

export default CurrencySymbol;
